module.exports = __webpack_public_path__ + "img/bg.7c2c4356.png";